import PhotoSwipeLightbox from "photoswipe-lightbox";
import Photoswipe from "photoswipe";
document.addEventListener('DOMContentLoaded', function() {
  window.onload = function() {
    // populate navyProductMediaData from html

    // PhotoSwipe initialization code...
    const options = {
      mainClass: 'pswp--navy',
      dataSource: [],
      showHideAnimationType: 'none',
      pswpModule: () => Photoswipe,
      counter: false,
      zoom: false,
      maxZoomLevel: 3,
    };
    const lightbox = new PhotoSwipeLightbox(options);
    lightbox.init();

    function checkImgSrcset(slickProducts) {
      return Array.from(slickProducts).every(slickProduct => {
        let imgElement = slickProduct.querySelector('img');
        return imgElement && imgElement.getAttribute('data-srcset');
      });
    }

    function addNavigationButtons() {
      const productSlides = document.querySelector('.product__slides');
      if (!productSlides) return;
  
      if (!productSlides.querySelector('.navy-product-slides-prev')) {
        const prevButton = document.createElement('button');
        prevButton.className = 'navy-product-slides-prev';
        prevButton.setAttribute('aria-label', 'Previous slide');
        prevButton.innerHTML = `
          <span class="navy-product-slides-icon-circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        `;
        productSlides.appendChild(prevButton);
      }
  
      if (!productSlides.querySelector('.navy-product-slides-next')) {
        const nextButton = document.createElement('button');
        nextButton.className = 'navy-product-slides-next';
        nextButton.setAttribute('aria-label', 'Next slide');
        nextButton.innerHTML = `
          <span class="navy-product-slides-icon-circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        `;
        productSlides.appendChild(nextButton);
      }
    }

    function populateNavyProductMediaData() {
      let navyProductMediaData = [];
      let slickProducts = document.querySelectorAll('.navy-product--wrapper .product__slides .slick-slide:not(.slick-cloned)');

      if (slickProducts) {
        let checkInterval = setInterval(() => {
          if (checkImgSrcset(slickProducts)) {
            clearInterval(checkInterval);
            for (let i = 0; i < slickProducts.length; i++) {
              let slickProduct = slickProducts[i];
              let imgElement = slickProduct.querySelector('img');
              let imgSrcset = imgElement.getAttribute('data-srcset');
              let imgAlt = imgElement.getAttribute('alt');
              let imgTitle = imgElement.getAttribute('aria-label');
              
              if (imgSrcset) {
                let imgSrcArray = imgSrcset.split(', ').map(src => src.split(' ')[0]);
                let largestImgSrc = imgSrcArray[imgSrcArray.length - 1];
                let largestImgWidth = largestImgSrc.match(/(\d+)x/)[1];
                let largestImgHeight = Math.round(largestImgWidth / (imgElement.naturalWidth / imgElement.naturalHeight));

                navyProductMediaData.push({
                  src: imgSrcArray[0], // Load a smaller image initially
                  srcset: imgSrcset,
                  sizes: "(min-width: 1124px) 524px, 50vw",
                  width: largestImgWidth,
                  height: largestImgHeight,
                  alt: imgAlt,
                  title: imgTitle
                });
              }
            }
            lightbox.options.dataSource = navyProductMediaData;
            addNavigationButtons();
          }
        }, 200);

        setTimeout(() => clearInterval(checkInterval), 10000);
      }
    }

    // Event listener code...
    document.addEventListener('click', function(event) {
        const slide = event.target.closest('.navy-product--wrapper .product__slides .slick-slide:not(.slick-cloned)');
        if (slide && lightbox.options.dataSource.length > 0) {
            const slickIndex = slide.getAttribute('data-slick-index');
            lightbox.loadAndOpen(parseInt(slickIndex));
        }

        const nextButton = event.target.closest('.navy-product-slides-next');
        const prevButton = event.target.closest('.navy-product-slides-prev');
        try {
          if (nextButton) {
              $(".navy-product--wrapper .product__slides").slick('next');
          } else if (prevButton) {
              $(".navy-product--wrapper .product__slides").slick('prev');
          }
        } catch (error) {  
          const slickDots = document.querySelector('.product__thumbs .slick-dots');
          if (slickDots) {
            const activeLi = slickDots.querySelector('.slick-active');
            if (nextButton) {
              const nextLi = activeLi.nextElementSibling || slickDots.firstElementChild;
              nextLi.querySelector('img').click();
            } else if (prevButton) {
              const prevLi = activeLi.previousElementSibling || slickDots.lastElementChild;
              prevLi.querySelector('img').click();
            }
          }
        }
    });

    // MutationObserver to watch for changes in .navy-product--wrapper
    const navyProductWrapper = document.querySelector('.navy-product--wrapper');
    if (navyProductWrapper) {
      const observer = new MutationObserver(function(mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            const productThumbs = navyProductWrapper.querySelector('.product__thumbs');
            if (productThumbs && (mutation.target === productThumbs || productThumbs.contains(mutation.target))) {
              console.log('Changes detected in .product__thumbs');
              populateNavyProductMediaData();
            }
          }
        }
      });

      observer.observe(navyProductWrapper, { attributes: true, childList: true, subtree: true });
    }
    
    populateNavyProductMediaData();
  }
});